const ARTWORK_LIST_CONTEXT_KEYS = [
  "listId",
  "imageListId",
  "workingListId",
  "imageWorkingListId",
];

const getArtworkListContext = search => {
  const query = new URLSearchParams(search);

  return Object.fromEntries(
    ARTWORK_LIST_CONTEXT_KEYS.flatMap(key => {
      const value = query.get(key);
      return value ? [[key, value]] : [];
    }),
  );
};

const buildArtworkListUrl = ({ listContext = {}, status = "all" } = {}) => {
  const query = new URLSearchParams({ status: status || "all" });

  ARTWORK_LIST_CONTEXT_KEYS.forEach(key => {
    if (listContext[key]) query.set(key, listContext[key]);
  });

  return `/artworks?${query.toString()}`;
};

const buildArtworkNavigationTargetUrl = ({
  activeSubPage = "details",
  listContext = {},
  recordId,
  status = "all",
} = {}) =>
  `/artworks/${recordId}/${activeSubPage || "details"}?${
    buildArtworkListUrl({
      listContext,
      status,
    }).split("?")[1]
  }`;

export {
  ARTWORK_LIST_CONTEXT_KEYS,
  buildArtworkListUrl,
  buildArtworkNavigationTargetUrl,
  getArtworkListContext,
};
